import { memo, useCallback } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";

import { GlobalSearchContent } from "./GlobalSearchContent";
import type { IGlobalSearchProps } from "./types";

// NOTE: NSAI-6589 — the global search palette (Cmd/Ctrl+K or the header search
// button). It grew out of the SearchChats dialog and keeps its chat sections.
// The cmdk root lives in GlobalSearchContent, which owns the highlight
// (NSAI-6762) and is unmounted while the dialog is closed.
// NSAI-6853 — drawn as a pane of "liquid glass" (`.glass-panel`,
// src/index.css) over a light scrim, so the page stays faintly visible behind
// it in either theme.
const GlobalSearchComponent = ({
  isOpen,
  onOpenChange,
}: IGlobalSearchProps): JSX.Element => {
  const handleClose = useCallback((): void => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        overlayClassName="glass-scrim"
        className="glass-panel w-[calc(100%-1.5rem)] max-w-[44rem] gap-0 overflow-hidden rounded-[1.75rem] p-0 text-foreground sm:rounded-[1.75rem]"
        data-testid="global-search-dialog"
      >
        <GlobalSearchContent onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
};

export const GlobalSearch = memo(GlobalSearchComponent);
